(function () {
  // Boot each Catechism Map video slot. Reads its config off data-* attributes
  // so we do not depend on a global SITE_CONFIG. Safe under Shopify's
  // section-load lifecycle: guards against re-entry with a data-boot flag.
  function boot(root) {
    if (!root || root.hasAttribute('data-cm-video-boot')) return;
    root.setAttribute('data-cm-video-boot', '1');
    var url = root.getAttribute('data-cm-video-script');
    if (!url) return;
    var fallback = root.querySelector('[data-cm-video-fallback]');
    var loaded = false;
    var s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onload  = function () { loaded = true; };
    s.onerror = function () { if (fallback) fallback.hidden = false; };
    document.head.appendChild(s);
    setTimeout(function () {
      if (!loaded && fallback) fallback.hidden = false;
    }, 8000);
  }

  function bootAll(scope) {
    var host = scope || document;
    var els = host.querySelectorAll('[data-cm-video-script]');
    for (var i = 0; i < els.length; i++) boot(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  // Theme editor rebind. NOTE: the underlying provider player attaches to a
  // fixed element id, so a full re-init after a customizer re-render is not
  // guaranteed. If the video does not reappear after editing this section,
  // press the theme editor's Refresh button.
  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target || undefined);
  });
})();
